import { CommonModule } from '@angular/common';
import { Component, OnInit, } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonUtilService } from '../../services/common-util/common-util.service';
@Component({
  selector: 'app-reach-success',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, CommonModule],
  templateUrl: './reach-success.component.html',
  styleUrl: './reach-success.component.scss',
})
export class ReachSucessComponent implements OnInit {

  public isMobileDevice: boolean = false;
  constructor(
    private isMobile: CommonUtilService,
  ) {}
  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
  }
}
